/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Premium_ButtonInputs */

const en_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Premium`)
};

const id_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadilah Premium`)
};

const ms_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertai Premium`)
};

const ca_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canvia a Premium`)
};

const cs_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejít na Premium`)
};

const da_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg Premium`)
};

const de_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt Premium sichern`)
};

const et_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liitu tasulise versiooniga`)
};

const es_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazte Premium`)
};

const fr_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à la version Premium`)
};

const hr_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pretplatite se na Premium`)
};

const it_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa alla versione Premium`)
};

const lv_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iegūt Premium`)
};

const lt_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Premium“`)
};

const hu_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prémium előfizetés`)
};

const nl_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koop Premium`)
};

const nb_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bruk premium`)
};

const pl_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź na wersję Premium`)
};

const pt_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assine o Premium`)
};

const ro_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alegeți Premium`)
};

const sk_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prejsť na Premium`)
};

const sl_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pridobi Premium`)
};

const fi_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siirry Premiumiin`)
};

const sv_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj Premium`)
};

const vi_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nâng cấp lên Premium`)
};

const tr_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium olun`)
};

const el_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιλέξτε το Premium`)
};

const bg_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мини на Премиум`)
};

const ru_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум-подписка`)
};

const sr_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пређи на премијум`)
};

const uk_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на версію Premium`)
};

const ka_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გადადით პრემიუმზე`)
};

const hi_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीमियम सदस्य बनें`)
};

const th_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้งาน Premium`)
};

const ko_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 가입`)
};

const zh_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅 Premium`)
};

const zh_tw_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱高級版`)
};

const ja_go_premium_button = /** @type {(inputs: Go_Premium_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアムプラン`)
};

/**
* | output |
* | --- |
* | "Go Premium" |
*
* @param {Go_Premium_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const go_premium_button = /** @type {((inputs?: Go_Premium_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Premium_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_go_premium_button(inputs)
	if (locale === "ms") return ms_go_premium_button(inputs)
	if (locale === "ca") return ca_go_premium_button(inputs)
	if (locale === "cs") return cs_go_premium_button(inputs)
	if (locale === "da") return da_go_premium_button(inputs)
	if (locale === "de") return de_go_premium_button(inputs)
	if (locale === "et") return et_go_premium_button(inputs)
	if (locale === "es") return es_go_premium_button(inputs)
	if (locale === "fr") return fr_go_premium_button(inputs)
	if (locale === "hr") return hr_go_premium_button(inputs)
	if (locale === "it") return it_go_premium_button(inputs)
	if (locale === "lv") return lv_go_premium_button(inputs)
	if (locale === "lt") return lt_go_premium_button(inputs)
	if (locale === "hu") return hu_go_premium_button(inputs)
	if (locale === "nl") return nl_go_premium_button(inputs)
	if (locale === "nb") return nb_go_premium_button(inputs)
	if (locale === "pl") return pl_go_premium_button(inputs)
	if (locale === "pt") return pt_go_premium_button(inputs)
	if (locale === "ro") return ro_go_premium_button(inputs)
	if (locale === "sk") return sk_go_premium_button(inputs)
	if (locale === "sl") return sl_go_premium_button(inputs)
	if (locale === "fi") return fi_go_premium_button(inputs)
	if (locale === "sv") return sv_go_premium_button(inputs)
	if (locale === "vi") return vi_go_premium_button(inputs)
	if (locale === "tr") return tr_go_premium_button(inputs)
	if (locale === "el") return el_go_premium_button(inputs)
	if (locale === "bg") return bg_go_premium_button(inputs)
	if (locale === "ru") return ru_go_premium_button(inputs)
	if (locale === "sr") return sr_go_premium_button(inputs)
	if (locale === "uk") return uk_go_premium_button(inputs)
	if (locale === "ka") return ka_go_premium_button(inputs)
	if (locale === "hi") return hi_go_premium_button(inputs)
	if (locale === "th") return th_go_premium_button(inputs)
	if (locale === "ko") return ko_go_premium_button(inputs)
	if (locale === "zh") return zh_go_premium_button(inputs)
	if (locale === "zh-tw") return zh_tw_go_premium_button(inputs)
	if (locale === "ja") return ja_go_premium_button(inputs)
	return en_go_premium_button(inputs)
});